import SecondHeader from "../Layout/SecondHeader";
import SecondFooter from "../Layout/SecondFooter";
import { Link } from "react-router-dom/cjs/react-router-dom";
export default function AboutUs() {
  const checkIcon = "/assets/images/Cance11r.png";
  return (
    <>
      <SecondHeader />
      <section className="About">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h3 class="heading mt-5 mb-4 text-center">About Us</h3>
              <p>
                We started working in healthcare more than 30 years ago. In the beginning, our work mainly consisted of preparing programs and following up with people who needed training and rehabilitation. In 2000, we opened our first treatment center. Our goal was to develop a complete health system that could help people from sick (cancer) to healthy.
              </p>
              <p className="text-center">
                <img src={checkIcon} alt="" />
              </p>
              <p>
                The road has been long, challenging, educational, and, above all, interesting. Our many years of experience and our great commitment to the development of treatment methods, studies of nutrition, physical training, mental training, and modern treatment technology, should make you feel confident that we deliver useful and powerful knowledge.
              </p>
              <p>
                Unfortunately, most people lack the knowledge and familiarity needed to activate the hidden resources and extract some of the great potential that our souls and bodies have to increase and improve health.
              </p>
              <p>
                Cancer Management has therefore developed a 12-month cancer recovery online program that will guide you through the process. The system should help you become aware of the potential you have. At the same time, it will provide exercises that can help to extract some of your personal resources. </p>
              <p>
                Awareness of one's own strengths is important in a recovery process, as it helps to get the most benefit from the program and the greatest possible increase in freshness and quality of life.
              </p>
              <p>
                Our chief medical officer has more than 25 years of experience as a leader in healthcare.
              </p>
              <p>
                Our founder, the author of <i>Secret of Health</i>, has a wealth of experience, ranging from ownership and management in health clinics, the fitness industry, teaching motivational programs, developing technology for healthcare, and working with effective diagnostic systems and modern, high-tech treatment tools.
              </p>
              <p class="mb-1">

                But when it comes to this 12-month cancer recovery online program, it is all about you. We have worked for years to find the best possible solutions and information that can make you stronger, more energized, and healthier.
              </p>
              <p>
                What are you waiting for? Start your recovery journey by filling out the form below.
              </p>
            </div>
            <p className="text-center">
              <button style={{
                width: 'auto',
                height: '50px',
                backgroundColor: 'green',
                color: 'white',
                borderRadius: '3px',
                border: 'none',
                padding: "0.5rem",
                paddingTop: "0.2rem",
                paddingBottom: "0.2rem",
              }}>
                <Link to='/cancer-recovery-management-online'
                  style={{
                    textDecoration: 'none',
                    color: 'white'
                  }}>
                  Click here to fill out the form

                </Link>
              </button>
            </p>
          </div>
        </div>
      </section >
      <SecondFooter />
    </>
  );
}
